import { render, staticRenderFns } from "./KeyValPairModal.vue?vue&type=template&id=58ada610&scoped=true"
import script from "./KeyValPairModal.vue?vue&type=script&lang=js"
export * from "./KeyValPairModal.vue?vue&type=script&lang=js"
import style0 from "./KeyValPairModal.vue?vue&type=style&index=0&id=58ada610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ada610",
  null
  
)

export default component.exports